<template>
    <div :class="{'single-radio': isSingle, 'single-radio-hor': isSingleHor, 'hidden-radio': isHidden}">
        <v-radio-group
                :label="label"
                class="radiogroup"
                :class="{'is-horizontal': horizontal}"
                :row="horizontal"
                :error="error"
                v-model="answerRadio"
                @change="onChange"
                hide-details
                :dark="dark"
        >
            <v-radio class="radiobutton"
                     :class="[{'is-less': item.answer.length < 4, 'is-medium': item.answer.length < 25 && item.answer.length > 3}]"
                     color="warn"
                     v-for="(item, i) in items"
                     :key="i"
                     :label="item.answer"
                     :value="getValue(i)"
                     hide-details
            />
        </v-radio-group>
        <v-text-field
                v-if="isOther"
                @change="onChange"
                :error="error"
                v-model="answerInput"
                :label="otherLabel"
        />
    </div>
</template>
<script>
    export default {
        props: {
            items: {
                type: Array,
                default: () => []
            },
            hasId: Boolean,
            hasIndex: Boolean,
            horizontal: Boolean,
            error: Boolean,
            dark: Boolean,
            label: String,
            value: [String, Number],
            id: [String, Number],
            isSingleHor: Boolean,
            isSingle: Boolean,
            isHidden: Number,
            indexOffset: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                answerRadio: '',
                answerInput: '',
                otherKey: 'Другое',
                otherLabel: 'Введите текст'
            }
        },
        computed: {
            isOther () {
                if (this.hasIndex) {
                    let index = parseInt(this.selectValue) - this.indexOffset
                    let item = this.items[index]
                    return item ? (item.value || item.answer) === this.otherKey : false
                } else {
                    return this.selectValue === this.otherKey
                }
            },
            selectValue () {
                if (this.hasId) {
                    let index = this.items.findIndex((item) => item.id === this.answerRadio)
                    if (index > -1) {
                        return this.items[index].value || this.items[index].answer
                    } else {
                        return ''
                    }
                } else if (this.hasIndex) {
                    return this.answerRadio
                } else {
                    return this.answerRadio
                }
            }
        },
        methods: {
            onChange () {
                let value = this.answerRadio.toString()
                if (this.isOther) {
                    value = this.answerInput
                }
                this.$emit('input', value)
            },
            getValue (i) {
                let item = this.items[i]

                if (this.hasId) {
                    return item.id
                } else if (this.hasIndex) {
                    return (i + this.indexOffset).toString()
                } else {
                    return item.value || item.answer
                }
            }
        },
        watch: {
            id () {
                this.answerRadio = ''
                this.answerInput = ''
            }
        }
    }
</script>
<style lang="stylus" scoped>
    .hidden-radio {
        opacity 0
        height 0
        overflow hidden
        pointer-events none
    }

    .single-radio-hor {
        .radiobutton {
            margin-bottom 0

            /deep/ label {
            }
        }
    }

    .single-radio {
        .radiobutton {
            margin-bottom 0
            width auto !important
            min-width 30px !important

            /deep/ label {
                top 70%
                left 25% !important
            }
        }
    }
    .radiogroup {
        padding 0
    }
    .is-less {
        width 70px!important
    }
    .is-medium {
        width 210px!important
        align-items center
    }

    .radiobutton {
        height auto
        position relative
        margin-bottom 15px

        /deep/ .input-group__input {
            position absolute
            top 50%
            transform translateY(-58%)
            left 0
            min-height 24px
        }

        /deep/ .material-icons {
            height 24px
        }

        /deep/ label {
            position relative
            flex 1 0 100%
            max-width calc(100% - 32px)
            white-space normal
            word-wrap break-word
            height auto
            top 0
            overflow initial
            line-height: 1.3
        }
    }
    /deep/ .is-horizontal .input-group__input > .radiobutton {
        min-width 70px
        flex none
        width auto
    }
</style>